import {Component, OnInit} from "@angular/core";
import {MemberService} from "../service/member/member.service";
import {ActivatedRoute, Router} from "@angular/router";
import {AuthService} from "../service/auth/auth.service";
import {GtmService} from "../service/gtm/gtm.service";

@Component({
  selector: 'app-find-password',
  templateUrl: './find-password.component.html',
  styleUrls: ['./find-password.component.scss'],
  providers: [MemberService]
})
export class FindPasswordComponent implements OnInit {

  constructor(private memberService: MemberService,
              private router: Router,
              private authService: AuthService,
              private route: ActivatedRoute,
              private gtmService: GtmService) {
    if (this.authService.canActivate()) {
      this.router.navigateByUrl('/');
    } else {
      this.gtmService.pageViewWithPage({
        'path': this.route.snapshot['_routerState'].url,
        'title': 'Find Password',
        'breadcrumb': 'Home > Member > Find Password'
      });
    }
  }

  ngOnInit() {
  }

  onFindPassword(form: any) {
    if (!form.email) {
      window.alert('이메일을 입력해 주세요.');
      return;
    }

    this.memberService.findPassword(form.email).subscribe(
      res => {
        window.alert('이메일로 비밀번호 재설정 메일이 전달되었습니다.');
        this.router.navigateByUrl('/');
      }
    )
  }
}



// WEBPACK FOOTER //
// ./src/app/find-password/find-password.component.ts